import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=e13f2e2a&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e13f2e2a')) {
      api.createRecord('e13f2e2a', component.options)
    } else {
      api.reload('e13f2e2a', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=e13f2e2a&", function () {
      api.rerender('e13f2e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HtzPjW1EL9Ne/JS/videoIframe.vue"
export default component.exports